import { Sparkles, Star, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const identifyReferralOpportunityRequestReferralAr: TemplateAr = {
  name: 'رصد فرص الترشيح + طلب ترشيح',
  description:
    'الذكاء الاصطناعي يرصد العملاء الراضين ويطلب منهم ترشيحاً تلقائياً في اللحظة المثالية مع عروض تحفيزية.',
  category: 'ذكاء الإيرادات',
  workflow: [
    { icon: Star, label: 'عميل راضٍ' },
    { icon: Sparkles, label: 'رصد ذكي' },
    { icon: Users, label: 'طلب ترشيح', final: true },
  ],
  detailDescription: {
    paragraph1:
      'اطلب الترشيح لمّا يكون العميل راضي فعلاً، مو بالتخمين. الـ AI يرصد درجات NPS العالية، والتفاعل الإيجابي مع الدعم، ونجاح تبنّي المنتج، واللغة المتحمسة. وبعدها يطلب الترشيح عبر الإيميل أو رسالة داخل التطبيق أو مكالمة، ومعه عرض تحفيزي مخصص.',
    paragraph2:
      'تتابع طلبات الترشيح والردود ونتائج التحويل في برنامج الترشيحات عندك أو في الـ CRM. والـ AI يتعلّم التوقيت الأمثل وهيكل الحوافز لكل شريحة. والترشيح اللي ينجح يشغّل صرف المكافأة ومسار العميل الجديد تلقائياً.',
  },
  benefits: [
    'أرخص قناة استحواذ عندك (CAC)',
    'ما تطلب ترشيحاً إلا من عميل راضٍ',
    'التوقيت يطلع من مؤشرات الرضا، مو من التخمين',
    'تتبّع الحوافز يجري تلقائياً، بلا جدول يدوي',
    'المشاركة في برنامج الترشيحات ترتفع',
    'تعرف كل ترشيح جاء من مين',
  ],
};
